import React, { Fragment, useEffect, useState } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { useNavigate, useLocation } from "react-router";
import { ArrowBack } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import InputField2 from "../../../common/InputComponents/InputField2";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";
import ToggleButtons from "../../../common/InputComponents/ToggleButtons";
import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
import { Box, Button } from "@mui/material";
import {
  useCreate,
  useGetIdentity,
  useGetList,
  useGetOne,
  useNotify,
  useRefresh,
  useStore,
} from "react-admin";
import { useParams } from "react-router-dom";
import save_icon from "../../../../assets/images/save_icon.svg";

const AddorUpdateIntegrationSettings = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const notify = useNotify();
  const refresh = useRefresh();
  const toggleEnabledButton = [
    {
      value: 0,
      label: "Disabled",
      icon: <ClearIcon />,
      borderColor: "#909090",
      backgroundColor: "#EEE",
      boxShadowColor: "#90909033",
      color: "#606060",
    },
    {
      value: 1,
      label: "Enabled",
      icon: <CheckIcon />,
      borderColor: "#46A96F",
      backgroundColor: "#EBFFF3",
      boxShadowColor: "#46a96f1a",
      color: "#46A96F",
    },
  ];

  const [switchSubscriberObj] = useStore("switchSubscriberName");
  const { data: identity } = useGetIdentity();
  const { id } = useParams();

  // get integration-setting-rule details
  const {
    data: getIntegrationSettingRuleDetails,
    isLoading: loadingIntegrationSettingRuleDetails,
  } = useGetList(
    "integration-setting-rule",
    {
      filter: {
        subscriberID: switchSubscriberObj?.value,
        thirdPartyAppId: state?.thirdPartyAppId,
        id: id,
      },
    },
    {
      enabled:
        switchSubscriberObj?.value && id && state?.thirdPartyAppId
          ? true
          : false,
      refetchOnWindowFocus: false,
    }
  );

  // form validation schema
  const validationSchema = yup.lazy((value) =>
    yup.object().shape({
      ruleName: yup
        .string()
        .typeError("Required!")
        .min(2, "minimum 2 characters is required")
        .required("Required!"),
      sendIDProof: yup.string().required("Required!"),
      sendProofOfIncome: yup.string().required("Required!"),
      sendBankStatement: yup.string().required("Required!"),
      sendOtherDocuments: yup.string().required("Required!"),
    })
  );

  // Initial form values
  const defaultFormValues = {
    ruleName: "",
    sendIDProof: 1,
    sendProofOfIncome: 1,
    sendBankStatement: 1,
    sendOtherDocuments: 1,
    sendSSNDocument: 1,
  };

  const methods = useForm({
    defaultValues: defaultFormValues,
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  useEffect(() => {
    if (!state?.isAdding) {
      let data =
        getIntegrationSettingRuleDetails && getIntegrationSettingRuleDetails[0];
      const getFormData: any = {
        ruleName: data?.ruleName,
        sendIDProof: data?.sendIDProof,
        sendProofOfIncome: data?.sendProofOfIncome,
        sendBankStatement: data?.sendBankStatement,
        sendOtherDocuments: data?.sendOtherDocuments,
        sendSSNDocument: data?.sendSSNDocument,
      };
      methods.reset(getFormData);
    }
  }, [
    getIntegrationSettingRuleDetails && getIntegrationSettingRuleDetails[0],
    methods,
  ]);

  const [create, { isLoading, error }] = useCreate();

  // form submit handler
  const onSubmit = (value) => {
    const addData = {
      subscriberID: switchSubscriberObj?.value,
      thirdPartyAppID: state?.thirdPartyAppId,
      ...value,
    };
    const updateData = { ...value, ID: id };
    create(
      state?.isAdding
        ? `add-integration-setting-rule`
        : `update-integration-setting-rule`,
      { data: state?.isAdding ? addData : updateData },
      {
        onSuccess: (data) => {
          notify(
            state?.isAdding
              ? `Integration settings created successfully.`
              : `Integration settings updated successfully.`,
            {
              type: "success",
              anchorOrigin: { vertical: "top", horizontal: "right" },
            }
          );
          refresh();
          methods?.reset();
          navigate(-1);
        },
        onError: (e: any) =>
          notify(`Operation fail:${e.message}`, {
            type: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          }),
      }
    );
  };

  // useEffect(() => {
  //   document.title = state?.isAdding
  //     ? "Integration Settings - Add Integration Setting"
  //     : "Integration Settings - Integration Details";
  // }, []);

  return (
    <Fragment>
      <div className="home_content">
        <div className="row">
          <div className="col-12 d-flex">
            <Breadcrumbs aria-label="breadcrumb">
              <Typography sx={{ fontWeight: "bold" }}>
                <button
                  title="Go Back"
                  style={{ color: "#2cc0e4" }}
                  className="btn btn-link"
                  onClick={() => navigate(-1)}
                >
                  <ArrowBack />
                </button>
                {state?.isAdding ? (
                  <span>Add Integration Setting</span>
                ) : (
                  <span>Integration Details</span>
                )}
              </Typography>
            </Breadcrumbs>
          </div>
        </div>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)} className="mr-t30">
            <div className="row">
              <div className="col-sm-12 col-md-4 col-lg-4 mr-b20">
                <InputField2
                  label="Rule Name"
                  source={`ruleName`}
                  placeholder="Enter Rule Name"
                  labelClass={"lable-title"}
                  additionalInputClass={"cus-control"}
                />
              </div>
              <div className="col-sm-12 col-md-4 col-lg-4 mr-b20"></div>
              <div className="col-sm-12 col-md-4 col-lg-4 mr-b20"></div>
              <div className="col-sm-12 col-md-3 col-lg-3 mr-b20">
                <ToggleButtons
                  toggleButton={toggleEnabledButton}
                  label="Send ID Proof"
                  labelClass={"lable-title"}
                  source={`sendIDProof`}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3 mr-b20">
                <ToggleButtons
                  toggleButton={toggleEnabledButton}
                  label="Send Proof of Income"
                  labelClass={"lable-title"}
                  source={`sendProofOfIncome`}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3 mr-b20">
                <ToggleButtons
                  toggleButton={toggleEnabledButton}
                  label="Send Bank Statement"
                  labelClass={"lable-title"}
                  source={`sendBankStatement`}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3 mr-b20">
                <ToggleButtons
                  toggleButton={toggleEnabledButton}
                  label="Send Other Documents"
                  labelClass={"lable-title"}
                  source={`sendOtherDocuments`}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3 mr-b20">
                <ToggleButtons
                  toggleButton={toggleEnabledButton}
                  label="Send SSN Documents"
                  labelClass={"lable-title"}
                  source={`sendSSNDocument`}
                />
              </div>
            </div>

            <Box
              sx={{
                height: "60px",
                background: "#F5FDFF",
                boxShadow: "0px -1px 12px 0px rgba(0, 0, 0, 0.12)",
              }}
              display={"flex"}
              justifyContent={"end"}
              alignItems={"center"}
              className="sticky-bottom mt-4"
            >
              <Box>
                <Button
                  sx={{ mx: 1 }}
                  onClick={() => {
                    refresh();
                    methods?.reset();
                    navigate(-1);
                  }}
                  variant="outlined"
                  color="secondary"
                  type="button"
                >
                  Cancel
                </Button>
                <Button
                  startIcon={
                    state?.isAdding ? (
                      <CheckIcon />
                    ) : (
                      <img src={save_icon} alt="save icon" />
                    )
                  }
                  sx={{ mx: 1 }}
                  variant="contained"
                  type="submit"
                  disabled={isLoading}
                >
                  {state?.isAdding ? `Create Integration Settings` : `Update`}
                </Button>
              </Box>
            </Box>
          </form>
        </FormProvider>
      </div>
    </Fragment>
  );
};

export default AddorUpdateIntegrationSettings;
